<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { masifiWaPreviewAuthor } from 'dashboard/helper/masifi/masifiWaGroups';

// "Jvr: " delante de la vista previa del último mensaje de un grupo (como WhatsApp; E2E fix batch 1). Un compañero se
// nombra como en la burbuja ("Equipo · Ana"). Nada para 1:1, líneas de actividad ni lo que escribe nuestro agente.
const props = defineProps({ message: { type: Object, default: () => ({}) } });
const { t } = useI18n();
const author = computed(() => masifiWaPreviewAuthor(props.message));
const label = computed(() =>
  author.value?.team
    ? t('MASIFI_WHATSAPP_QR.GROUPS.AUTHOR.TEAM', { name: author.value.name })
    : author.value?.name
);
</script>

<template>
  <span v-if="author" data-test="masifi-wa-author-prefix" class="font-medium">
    {{ `${label}: ` }}
  </span>
</template>
